import { IReportMediaOptions } from "../types/reportsInterfaces";

export const sortByDate = (medias: IReportMediaOptions[]) =>
  medias
    ?.filter((elem: IReportMediaOptions) => elem?.date)
    ?.sort(
      (firstMedia: IReportMediaOptions, secondMedia: IReportMediaOptions) =>
        new Date(firstMedia.date).getTime() -
        new Date(secondMedia.date).getTime()
    );
